import * as types from "../ActionTypes/actionTypes.js";

export default function (
  state = {
    isFetching: false,
    authenticated: false,
    isAuthenticated: !!localStorage.getItem("access_token"),
    actionType: "",
    errorMessage: "",
    inProgressMaintenances: [],
    InProgressInspections: [],
  },
  action,
) {
  switch (action.type) {
    case types.GET_IN_PROGRESS_MAINTENANCE_REQUEST:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        isSuccess: false,
        errorMessage: "",
        actionType: action.type,
      };
    case types.GET_IN_PROGRESS_MAINTENANCE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: "",
        isSuccess: true,
        inProgressMaintenances: action.response,
        actionType: action.type,
      };
    case types.GET_IN_PROGRESS_MAINTENANCE_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.error || "Error: Unable to Create msgList",
        isSuccess: false,
        actionType: action.type,
      };
    case types.GET_IN_PROGRESS_INSPECTIONS_REQUEST:
      return {
        ...state,
        isFetching: true,
        isAuthenticated: false,
        isSuccess: false,
        errorMessage: "",
        actionType: action.type,
      };
    case types.GET_IN_PROGRESS_INSPECTIONS_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: true,
        errorMessage: "",
        isSuccess: true,
        InProgressInspections: action.response,
        actionType: action.type,
      };
    case types.GET_IN_PROGRESS_INSPECTIONS_FAILURE:
      return {
        ...state,
        isFetching: false,
        isAuthenticated: false,
        errorMessage: action.error || "Error: Unable to Get",
        isSuccess: false,
        actionType: action.type,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reduxRelated/reducer/journeyPlanHelperReducer.js